import { Component, OnInit, Input } from "@angular/core";
import { ZpDataService } from "../services/zp-data.service";
import { Router } from "@angular/router";
import { ThemeService } from "../theme/theme-service.service";
declare let Swiper: any;

@Component({
    selector: "app-suggested-next-steps",
    templateUrl: "./suggested-next-steps.component.html",
    styleUrls: ["./suggested-next-steps.component.scss"],
    standalone: false
})
export class SuggestedNextStepsComponent implements OnInit {
  @Input() public myCategoriesBalance;
  public myUser;
  public resultsNextSteps;
  public results: any[];
  public noEmpty: boolean;
  public swiper;
  public themeStatus: string;
  public text: string;
  public isDefaultTheme: boolean;
  refCode: any;
  companyDetails: any;
  constructor(
    private api: ZpDataService,
    private router: Router,
    public themeService: ThemeService
  ) {}

  ngAfterViewInit() {}

  async ngOnInit() {
    if (!this.myUser) {
      this.myUser = await this.api.getUser();
    }
    console.log("myUser: ", this.myUser);
    this.refCode = this.myUser.refCode;
    console.log("refCode: ", this.refCode);
    await this.api.setRefCode(this.refCode);
    this.companyDetails = await this.api.getRefCodeInfo();
    console.log("companyDetails: ", this.companyDetails);
    this.themeStatus = this.themeService.theme;
    if (this.themeStatus != "default") {
      this.text = "your plan";
      this.isDefaultTheme == false;
    } else {
      this.text = "Zenplans";
      this.isDefaultTheme == true;
    }

    let result = await this.api.retrieveSuggestedNextSteps();
    this.resultsNextSteps = result;
    console.log('resultsNextSteps', this.resultsNextSteps);
    if (result.success) {
      if ((this.resultsNextSteps = result.results)) {
        this.resultsNextSteps.forEach((step) => {
          if (step.buttonLink.startsWith("func:")) {
            step.buttonFunc = step.buttonLink.replace(/^func\:/, "");
          }
        });
      }
      if (this.resultsNextSteps.length === 0) {
        this.noEmpty = false;
      } else {
        this.noEmpty = true;
      }
    }
    let _self = this;
    setTimeout(function () {
      _self.swiper = new Swiper(".swiper-container", {
        slidesPerView: 3,
        spaceBetween: 50,
        speed: 600,
        // autoplay: 3000,
        centeredSlides: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        nextButton: ".next-step",
        prevButton: ".prev-step",
        observer: true,
        observeParents: true,
        disabledClass: "swiper-button-disabled",
      });
      function geSlideDataIndex(swipe) {
        var activeIndex = swipe.activeIndex;
        var slidesLen = swipe.slides.length;
        // Carousel intro
        if (activeIndex == 0) {
          document.getElementById("mostZp").classList.remove("disabled");
        } else if (activeIndex >= 1) {
          document.getElementById("mostZp").classList.add("disabled");
        }
        // In case of loop
        if (swipe.params.loop) {
          switch (swipe.activeIndex) {
            case 0:
              activeIndex = slidesLen - 3;
              break;
            case slidesLen - 1:
              activeIndex = 0;
              break;
            default:
              --activeIndex;
          }
        }
        return activeIndex;
      }
    }, 0);
  }

  handleButtonFunc(func) {
    console.log("func", func);
    if (func === 'autoInviteProfessionalDelegate') {
      this.api.inviteProfessionalAsDelegate(this.refCode, this.companyDetails.profession, "no-notif", this.companyDetails)
    } else {
      this.api[func]();
    }
  }

  async skip(id, index) {
    let result = await this.api.skipNextStepSuggestion(id);
    this.swiper.removeSlide(this.swiper.activeIndex);
    this.swiper.update();
  }
}
